import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
    { label: "Services", href: "#services" },
    { label: "Process", href: "#process" },
    { label: "Portfolio", href: "#portfolio" },
    { label: "About", href: "#about" },
    { label: "Contact", href: "#contact" },
];

export default function Nav() {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 24);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    // Prevent body scroll while mobile menu is open
    useEffect(() => {
        if (open) {
            const prev = document.body.style.overflow;
            document.body.style.overflow = "hidden";
            return () => {
                document.body.style.overflow = prev;
            };
        }
    }, [open]);

    const close = () => setOpen(false);

    return (
        <>
            <header
                data-testid="site-nav"
                className={`fixed top-0 left-0 right-0 z-40 transition-all duration-500 ${
                    scrolled
                        ? "backdrop-blur-xl bg-background/80 border-b border-border/60"
                        : "bg-transparent"
                }`}
            >
                <div className="container-edge flex items-center justify-between py-5">
                    <a
                        href="#top"
                        data-testid="nav-logo"
                        className="font-display text-[17px] tracking-tight font-medium"
                    >
                        Alfie Carter
                    </a>

                    <nav className="hidden md:flex items-center gap-9">
                        {links.map((l) => (
                            <a
                                key={l.href}
                                href={l.href}
                                data-testid={`nav-link-${l.label.toLowerCase()}`}
                                className="text-[12px] tracking-[0.12em] uppercase text-foreground/70 hover:text-foreground transition-colors"
                            >
                                {l.label}
                            </a>
                        ))}
                    </nav>

                    <div className="hidden md:block">
                        <a
                            href="#contact"
                            data-testid="nav-cta-start-project"
                            className="btn-primary"
                        >
                            Start a Project
                        </a>
                    </div>

                    <button
                        onClick={() => setOpen(true)}
                        data-testid="mobile-menu-open"
                        className="md:hidden p-2 -mr-2 text-foreground"
                        aria-label="Open menu"
                    >
                        <Menu size={22} />
                    </button>
                </div>
            </header>

            {/* Mobile menu — rendered as a sibling of <header> so it isn't
                trapped by the header's backdrop-blur containing block.
                Explicit inline background ensures full opacity on every browser. */}
            <div
                className={`md:hidden fixed inset-0 z-[70] transition-transform duration-500 ${
                    open ? "translate-x-0" : "translate-x-full"
                }`}
                data-testid="mobile-menu"
                aria-hidden={!open}
                style={{ backgroundColor: "#EFEAE2" }}
            >
                <div className="container-edge flex items-center justify-between py-5">
                    <span className="font-display text-[17px] tracking-tight font-medium">
                        Alfie Carter
                    </span>
                    <button
                        onClick={close}
                        data-testid="mobile-menu-close"
                        className="p-2 -mr-2"
                        aria-label="Close menu"
                    >
                        <X size={22} />
                    </button>
                </div>
                <div className="container-edge mt-12 flex flex-col gap-6">
                    {links.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            onClick={close}
                            data-testid={`mobile-nav-link-${l.label.toLowerCase()}`}
                            className="font-display text-4xl tracking-tight border-b border-border pb-6"
                        >
                            {l.label}
                        </a>
                    ))}
                    <a
                        href="#contact"
                        onClick={close}
                        data-testid="mobile-nav-cta"
                        className="btn-primary mt-6 w-full"
                    >
                        Start a Project
                    </a>
                </div>
            </div>
        </>
    );
}
